var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8572 5.71429V0.446429C13.0209 0.550595 13.1548 0.654762 13.2589 0.758929L17.8125 5.3125C17.9167 5.41667 18.0208 5.5506 18.125 5.71429H12.8572ZM11.4286 6.07143C11.4286 6.36905 11.5328 6.62202 11.7411 6.83036C11.9494 7.03869 12.2024 7.14286 12.5 7.14286H18.5714V18.9286C18.5714 19.2262 18.4673 19.4792 18.2589 19.6875C18.0506 19.8958 17.7976 20 17.5 20H2.50002C2.2024 20 1.94942 19.8958 1.74109 19.6875C1.53276 19.4792 1.42859 19.2262 1.42859 18.9286V1.07143C1.42859 0.77381 1.53276 0.520833 1.74109 0.3125C1.94942 0.104167 2.2024 0 2.50002 0H11.4286V6.07143Z",
    fill: "#0A4468"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e0f38ad0c94a69f8728405e1eea5ecb6.svg";
export { ForwardRef as ReactComponent };